import React from 'react';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';
import { authService } from '../services/authService';
import styles from './Login.module.css';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = { email: '', password: '', error: '', loading: false };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ error: 'Enter both email and password.' });
      return;
    }
    this.setState({ loading: true, error: '' });
    authService.login(email, password)
      .then(() => this.props.onLoggedIn())
      .catch((err) => this.setState({ loading: false, error: err.message || 'Login failed.' }));
  }

  render() {
    const { email, password, error, loading } = this.state;
    return (
      <div className={styles.wrap}>
        <form className={styles.card} onSubmit={this.handleSubmit}>
          <div className={styles.logo}>PMW Click</div>
          <div className={styles.sub}>Sign in to your dashboard</div>

          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => this.setState({ email: e.target.value })}
            placeholder="you@company.com"
          />
          <Input
            label="Password"
            type="password"
            value={password}
            onChange={(e) => this.setState({ password: e.target.value })}
            placeholder="••••••••"
          />

          {error && <div className={styles.error}>{error}</div>}

          <Button variant="primary" size="lg" loading={loading} className={styles.submit}>
            Sign in
          </Button>
        </form>
      </div>
    );
  }
}

export default Login;
